import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 該当データを判断する */
enum IsThisInclude {
  include = '1',
  notInclude = '2',
  onlyApplicable = '3',
}

const nameConfig = {
  include: new Map([[Locale.ja, '含める']]),
  notInclude: new Map([[Locale.ja, '含めない']]),
  onlyApplicable: new Map([[Locale.ja, '該当のみ']]),
};

const toEnum = rawValueToEnum(IsThisInclude, IsThisInclude.include);
const toDisplay = enumToName(IsThisInclude, nameConfig);
const toDisplayWithPrefix = enumToName(IsThisInclude, nameConfig, { prefix: true });

export const isThisInclude = {
  enum: IsThisInclude,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { IsThisInclude };
